import { type CreditCardProviderOption } from '@webapp/platform/banking'
import { useCreditCardProviderInlineCreatePresenter } from './useCreditCardProviderInlineCreatePresenter'
import { CreditCardProviderInlineCreateView } from '../../views/CreditCardProviderInlineCreateView'

export interface ICreditCardProviderInlineCreatePresenterProps {
  /** Controlled new-provider name, seeded from the select's search term */
  name: string
  onNameChange: (name: string) => void
  /** The created provider, already appended to the select's options */
  onCreated: (provider: CreditCardProviderOption) => void
  onCancel: () => void
}

/**
 * Inline "Create new" form for CreditCardProviderSelect (BHV-018). Rendered by
 * the consumer after the select's form control, not inside it, so the select's
 * error stays directly under it.
 */
export const CreditCardProviderInlineCreatePresenter = ({
  name,
  onNameChange,
  onCreated,
  onCancel,
}: ICreditCardProviderInlineCreatePresenterProps) => {
  const {
    refs: { nameInputRef },
    states: { isSaving },
    handlers: { handleCreate, handleNameKeyDown },
  } = useCreditCardProviderInlineCreatePresenter({ name, onCreated })

  return (
    <CreditCardProviderInlineCreateView
      name={name}
      nameInputRef={nameInputRef}
      isSaving={isSaving}
      onNameChange={onNameChange}
      onNameKeyDown={handleNameKeyDown}
      onCreate={handleCreate}
      onCancel={onCancel}
    />
  )
}
